window.createProductionProcessInput = function(production_process_id, product_classification){
  let creation_data;
  let product_data = { input_type: 'harvested_product', measure_unit: 'grams' }
  let supply_data = {input_type: 'ingredient', measure_unit: 'units'}
  let elaboration_input_data = {input_type: 'processed_product'}
  if(product_classification == 'product'){creation_data = product_data}
  if(product_classification == 'supply'){creation_data = supply_data}
  if(product_classification == 'elaboration_input'){creation_data = elaboration_input_data}

  $.ajax({
    url: '/factory/production/production_processes/'+production_process_id+'/production_process_inputs',
    type: 'POST',
    data:{
      production_process_input_creation: creation_data
    }
  }).done(function(e) {});
}

window.updateProductionProcessInput = function(production_process_id, element_id, dom_id, product_classification){

  let product_id = $('#production-process-input-'+product_classification+'-name-'+dom_id).val();
  let quantity = $('#production-process-input-'+product_classification+'-quantity-'+dom_id).val();
  let comments = $('#production-process-input-'+product_classification+'-comments-'+dom_id).val();
  let code = $('#production-process-input-'+product_classification+'-code-'+dom_id).val();

  let main_data = {product_id: product_id, code: code, quantity: quantity, comments: comments}

  if(product_classification == 'product'){
    main_data.registration_hour = $('#production-process-input-product-registration-hour-'+dom_id).val();
    main_data.destiny_item_id = $('#production-process-input-product-destiny_item_id-'+dom_id).val();
  }
  if(product_classification == 'supply'){
    main_data.provider_id = $('#production-process-input-supply-provider-id-'+dom_id).val();
    main_data.measure_unit = $('#production-process-input-supply-measure-unit-'+dom_id).val();
  }

  $.ajax({
    url: '/factory/production/production_processes/'+production_process_id+'/production_process_inputs/'+element_id,
    type: 'PATCH',
    data:{
      production_process_input: main_data
    }
  }).done(function(e) {});

}

window.removeProductionProcessInput = function(production_process_id, element_id){
  $.ajax({
    url: '/factory/production/production_processes/'+production_process_id+'/production_process_inputs/'+element_id,
    type: 'DELETE'
  }).done(function(e) {});

}

window.createThermicalProcessRecord = function(production_process_id){
  $.ajax({
    url: '/factory/production/production_processes/'+production_process_id+'/thermical_process_records',
    type: 'POST'
  }).done(function(e) {});

}

window.updateThermicalProcessRecord = function(production_process_id, thermical_process_record_id, dom_id){
  production_process_input_id = $('#thermical-process-record-production-process-input-id-'+dom_id).val();
  weight = $('#thermical-process-record-weight-'+dom_id).val();
  process_type = $('#thermical-process-record-process-type-'+dom_id).val();
  furniture_id = $('#thermical-process-record-furniture-id-'+dom_id).val();
  temperature = $('#thermical-process-record-temperature-'+dom_id).val();
  registration_hour = $('#thermical-process-record-registration-hour-'+dom_id).val();
  registration_date = $('#thermical-process-record-registration-date-'+dom_id).val();
  comments = $('#thermical-process-record-comments-'+dom_id).val();
  
  $.ajax({
    url: '/factory/production/production_processes/'+production_process_id+'/thermical_process_records/'+thermical_process_record_id,
    type: 'PATCH',
    data:{
      thermical_process_record: {
        production_process_input_id: production_process_input_id,
        weight: weight,
        process_type: process_type,
        furniture_id: furniture_id,
        temperature: temperature,
        registration_hour: registration_hour,
        registration_date: registration_date,
        comments: comments
      }
    }
  }).done(function(e) {});

}

window.removeThermicalProcessRecord = function(production_process_id, thermical_process_record_id){
  $.ajax({
    url: '/factory/production/production_processes/'+production_process_id+'/thermical_process_records/'+thermical_process_record_id,
    type: 'DELETE'
  }).done(function(e) {});

}

window.createProductionProcessInputElaborationIn = function(production_process_id){
  let classification, type, product_type, supply_type, creation_data;
  [classification, type] = $('#production-process-input-selector').val().split(',');
  
  switch (type) {
    case 'harvested_product':
      creation_data = { provider_id: 1, input_type: 'harvested_product', measure_unit: 'grams' };
      break;
    case 'processed_product':
      creation_data = { provider_id: 1, input_type: 'processed_product', measure_unit: 'units' };
      break;
    case 'ingredient':
      creation_data = { input_type: 'ingredient', measure_unit: 'units' };
      break;
    case 'packaging':
      creation_data = { input_type: 'packaging', measure_unit: 'units' };
      break;
  }

  if(classification == 'product'){product_type = type};
  if(classification == 'supply'){supply_type = type};

  $.ajax({
    url: '/factory/production/production_processes/'+production_process_id+'/production_process_inputs',
    type: 'POST',
    data:{
      production_process_input_creation: creation_data,
      product: {
        classification: classification,
        product_type: product_type,
        supply_type: supply_type
      }
    }
  }).done(function(e) {});
}

window.updateProductionProcessInputElaborationIn = function(production_process_id, production_process_input_id, dom_id){

  let product_id = $('#production-process-input-product-id-'+dom_id).val();
  let provider_id = $('#production-process-input-supply-provider-id-'+dom_id).val();
  let code = $('#production-process-input-code-'+dom_id).val();
  let quantity = $('#production-process-input-quantity-'+dom_id).val();
  let waste = $('#production-process-input-waste-'+dom_id).val();
  let stock = $('#production-process-input-stock-'+dom_id).val();
  let comments = $('#production-process-input-comments-'+dom_id).val();
  
  $.ajax({
    url: '/factory/production/production_processes/'+production_process_id+'/production_process_inputs/'+production_process_input_id,
    type: 'PATCH',
    data:{
      production_process_input: {
        product_id: product_id,
        provider_id: provider_id,
        code: code,
        quantity: quantity,
        waste: waste,
        stock: stock,
        comments: comments
      }
    }
  }).done(function(e) {});

}
